import React from 'react';
import { Row, Col } from 'react-bootstrap';
import is from 'is_js';
import { useParams, useLocation } from 'react-router-dom';

const Branding = () => {
  const { guid } = useParams();
  const isHD = !guid.match(/^r-/);
  const mobile = is.mobile();
  const search = useLocation().search;
  const searchParams = new URLSearchParams(search);
  const isPrinting = !!searchParams.get('printing');
  const smaller = isPrinting || mobile;
  return (
    <Row
      className={isPrinting ? 'py-4 px-lg-4 py-lg-3' : 'py-4 px-lg-7 py-lg-3'}
    >
      {isHD && (
        <Col className="text-center">
          <img
            width={smaller ? '100' : '150'}
            height={smaller ? '100' : '150'}
            src="/hdlogo.svg"
            data-src="/hdlogo.svg"
            className=""
            alt="Home Depot Logo"
          />
        </Col>
      )}
      <Col className="text-center">
        <img
          style={{ backgroundColor: '#263A64' }}
          width={mobile ? '100' : isPrinting ? '100' : '150'}
          height={mobile ? '100' : isPrinting ? '100' : '150'}
          src="/precision-logo.svg"
          data-src="/precision-logo.svg"
          className=""
          alt="Precision Countertops Logo"
        />
      </Col>
    </Row>
  );
};

export default Branding;
